<template>
  <Hero
  titulo='Películas de Alta Performance para Segurança, Conforto e Estilo'
  descricao="Oferecemos a mais completa linha de películas para vidros: automotivas, arquitetônicas, de segurança e nano cerâmica. Proteja e valorize seus espaços com tecnologia de ponta e uma marca exclusiva que garante qualidade e durabilidade."
  :botao="'Acesse Nossos Produtos'"
  :rotaBotao="'/products'"
  :mostrarBotao="true"
  :mostrarSpan="true"
  :rotaSpan="'/products'"
  :textoSpan="'Linha de Películas Sublime Blue'"
  :span-tipo="'NEW'"
  ></Hero>

  <section class="bg-white">
    <div class="gap-16 items-center py-8 px-4 mx-auto max-w-screen-xl lg:grid lg:grid-cols-2 lg:py-16 lg:px-6">
      <div class="font-light text-gray-500 sm:text-lg">
        <h2 class="mb-4 text-4xl tracking-tight font-extrabold text-gray-900">Películas que vão além da estética</h2>
        <p class="mb-4">Linhas selecionadas de películas térmicas, de segurança, arquitetônicas e decorativas. Produtos que unem proteção, conforto e design pra transformar qualquer ambiente.
          Seja pra renovar um espaço, bloquear o calor ou garantir mais privacidade, aqui você encontra o material ideal com qualidade de ponta.</p>
      </div>
      <div class="grid grid-cols-2 gap-4 mt-8">
        <img class="w-full rounded-lg" src="@/assets/images/rolo-de-pelicula.jpeg" alt="Rolo de Película Sob a Mesa">
        <img class="mt-4 w-full lg:mt-10 rounded-lg" src="@/assets/images/vidraça-com-insufilm.jpeg" alt="Vidraça de sala com películas aplicadas">
      </div>
    </div>
  </section>

  <Categorias />

  <section class="bg-white">
    <div class="gap-16 items-center py-8 px-4 mx-auto max-w-screen-xl lg:grid lg:grid-cols-2 lg:py-16 lg:px-6">
      <div class="font-light text-gray-500 sm:text-lg">
        <h2 class="mb-4 text-4xl tracking-tight font-extrabold text-gray-900">Diversas Lojas no Nordeste</h2>
        <p class="mb-4">A Quantum tem orgulho em informar que estamos espalhados por diversas regiões no Nordeste,
          incluindo Fortaleza - CE, São Luis - MA e Imperatriz - MA. Seja onde estiver no Nordeste sempre tem uma
          Quantum próximo de você.</p>
      </div>
      <div class="grid grid-cols-2 gap-4 mt-8">
        <img class="mt-4 w-full lg:mt-10 rounded-lg"
          src="@/assets/images/mapa-cidades-quantum.webp" alt="Mapa com Localização das Filiais">
        <img class="w-full rounded-lg"
          src="@/assets/images/muitas-bobinas.webp" alt="Muitas Bobinas de Insufilm">
      </div>
    </div>
  </section>

  <QuemSomos />

</template>

<script>
import Hero from '@/components/HeroComponent/HeroComponent.vue';
import Categorias from '@/components/CategoriaComponent.vue'
import QuemSomos from '@/components/QuemSomos.vue';

export default {
  name: 'HomeView',
  components: {
    Hero, Categorias, QuemSomos
  }
}
</script>
